module.exports = __webpack_public_path__ + "static/img/ycks1.08b2e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/appopen/appopen/ycks1.png
// module id = VsE9
// module chunks = 0